import React, {useEffect, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import Moment from 'moment';
import DropDownInput from "../../../Input/dropDownInput/dropDownInput";
import SuccessModal from "../../../CustomModal/Success";
import FileUpload from "../../../FileUploads/FileUpload";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import useCurrentlocation from "../../../../hooks/currentlocation/useCurrentlocation";

const ParkingActivitySave = ({
                                 documentUploadUrlPublic,
                                 saveActivity,
                                 documentUrlDataPublic = [],
                                 history,
                                 match,
                                 getPendingActivity,
                                 saveActivityRes = [],
                                 activityTypesDetails = [],
                                 activityTypes,
                                 getSenior,
                                 senior = [],
                                 pendingActivity = [],
                                 markAttendance,
                                 attendance = [],
                                 isCheckout,
                                 isCheckoutDetails = [],
                                 accountById,
                                 accountDetailsByIdData = [],
                                 errorLogs
                             }) => {

    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        activity_type_id: '',
        activity_date: '',
        meta_data: {},
        lat: '',
        long: '',
        next_activity_type_id: '',
        next_activity_date: '',
        description: '',
        tagged_along: '',
        reason: []
    }])
    const [isActivityCreated, setIsActivityCreated] = useState(false)
    const [activityTypeId, setActivityTypeId] = useState('')
    const [distance, setDistance] = useState(0)
    const [currentDate, setCurrentDate] = useState(now.toISOString().slice(0, 16))
    const [taggedAlonedReportee, setTaggedAlonedReportee] = useState({})
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [openCheckIn, setOpenCheckIn] = useState(false)
    const [checkInText, setCheckInText] = useState('')
    const [reason, setReason] = useState([{}])
    const [isMockLocation, setIsMockLocation] = useState(false)
    const [hideCheckIn, setHideCheckIn] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false)
    const currentLocation = useCurrentlocation();

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getPendingActivity(match?.params?.account_id)
            await accountById(match?.params?.account_id)
            await activityTypes('is_parking')
            await getSenior()
            await isCheckout('Parking', match?.params?.account_id)
            setIsLoading(false)
        })()
    }, [])

    const toRad = (Value) => {
        return Value * Math.PI / 180
    }

    const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
    }

    const handleInput = (key, val, metaKey, e) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                let desc = e.target.selectedOptions[0].text;
                inputList[0][key][metaKey] = desc
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveActivityRes?.status === 200) {
            setIsSuccessModalOpen(true)
            // window.location.href = `dealer-activity-list/${match?.params?.module_id}`
        } else if (saveActivityRes?.status !== undefined && saveActivityRes?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [saveActivityRes])

    useEffect(() => {
        let values = ""
        let names = []
        if (taggedAlonedReportee !== [] && taggedAlonedReportee !== '' && taggedAlonedReportee.length > 0) {
            taggedAlonedReportee.map((val, i) => {
                names[i] = val?.name
                if (i === 0) {
                    values = val.id
                } else {
                    values += ',' + val.id
                }
            })
        }
        handleInput('tagged_along', values, '', '');
    }, [taggedAlonedReportee])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        if (list['next_activity_type_id'] === '') {
            toast.error("Please choose activity type")
            return false
        }
        list['next_activity_date'] = currentDate
        if (list['next_activity_date'] === '') {
            toast.error("Please choose next activity date")
            return false
        }

        list['pitched'] = reason
        list['account_id'] = match?.params?.account_id
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }

        if (isActivityCreated && list['next_activity_type_id'] !== '') {
            toast.error("Please complete your pending activity before creating new one.")
            return false
        }
        // console.log("listlistlist "+JSON.stringify(list))
        // return false
        setIsLoading(true)
        await saveActivity(list)
        setIsLoading(false)
    }

    useEffect(() => {
        if (pendingActivity?.data !== null && pendingActivity?.data !== undefined && Object.keys(pendingActivity?.data).length > 0) {
            setIsActivityCreated(true)
        }
    }, [pendingActivity])

    useEffect(() => {
        if (isCheckoutDetails?.data !== null && isCheckoutDetails?.data !== undefined && Object.keys(isCheckoutDetails?.data).length > 0) {
            setOpenCheckIn(true)
            setCheckInText("Check out")
        }
    }, [isCheckoutDetails, pendingActivity])

    useEffect(() => {

        if (pendingActivity?.data !== null && pendingActivity?.data !== undefined && Object.keys(pendingActivity?.data).length > 0) {
            (async () => {
                setIsActivityCreated(true)
                setIsLoading(true)
                await isCheckout(pendingActivity?.data?.id)
                setIsLoading(false)
            })()
        }
    }, [pendingActivity])

    useEffect(() => {
        // after check in hide popup
        if (attendance?.data !== undefined && attendance?.status === 200) {
            toast.success("Attendance is marked successfully")
            setOpenCheckIn(false)
        } else {
            toast.warning(attendance?.message)
        }
    }, [attendance, pendingActivity])

    const handleAddPitched = () => {
        setReason([
            ...reason,
            {pitched: ''}
        ])
    }

    const handleRemovePitched = (e, index) => {
        e.preventDefault()
        const list = [...reason]
        list.splice(index, 1);
        setReason(list);
    }

    const handlePitched = (val, i, e) => {
        let list = [...reason]

        let isProduct = false
        reason.map((value, i) => {
            if (value?.pitched === val) {
                isProduct = true
            }
        })
        if (isProduct) {
            handleRemovePitched(e, i)
            toast.warning(val + " already added in product pitched")
            return false
        }

        list[i]['pitched'] = val
        setReason(list)
    }

    useEffect(() => {

    }, [accountDetailsByIdData])

    useEffect(() => {
        if(currentLocation?.is_mock){
            setOpenCheckIn(false)
            setHideCheckIn(true)
            setDisableSubmit(true)
            setIsMockLocation(true)
            // toast.error('Location morphing is cheating. Check in not allowed');
            handleErrorLogsSave(`Location morphing is cheating. ${checkInText} not allowed`, checkInText);
            setCountToOpenModal(countToOpenModal+1);
        }
    }, [currentLocation])

    const handleErrorLogsSave = async (msg, type) => {
        setOpenCheckIn(false)
        setIsLoading(true)
        await errorLogs({
            module_type:"Parking",
            message: msg,
            type: type,
            device_id: window.localStorage.device_id ?? null
        });
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={saveActivityRes?.message}
                url={`parking-activity-list/${match?.params?.account_id}`}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={saveActivityRes?.message}
                countToOpenModal={countToOpenModal}
            />
            {isMockLocation &&
                <FailedModal
                    isOpen={isMockLocation}
                    msg={`Location morphing is cheating. ${checkInText} not allowed`}
                    countToOpenModal={countToOpenModal}
                    url={`parking-activity-list/${match?.params?.account_id}`}
                />
            }
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            {openCheckIn ?
                                <div className="box">
                                    <DistanceCalculator
                                        isMapShow={true}
                                        calculateDistance={markAttendance}
                                        moduleType={'Parking'}
                                        checkInText={checkInText}
                                        checkoutId={isCheckoutDetails?.data !== undefined ? isCheckoutDetails?.data?.id : 0}
                                        activityId={isCheckoutDetails?.data?.activity_id !== undefined ? isCheckoutDetails?.data?.activity_id : ""}
                                        accountId={isCheckoutDetails?.data?.account_id !== undefined ? isCheckoutDetails?.data?.account_id : ""}
                                        documentUploadUrlPublic={documentUploadUrlPublic}
                                        documentUrlDataPublic={documentUrlDataPublic}
                                        hideCheckButton={hideCheckIn}
                                    />
                                </div> :
                                <>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {/*<h1 className="h3 mb-0 text-black-100">*/}
                                                    {/*    <span style={{color: "green"}}>{distance}</span>*/}
                                                    {/*</h1>*/}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_type_id', e.target.value, e)
                                                                        setActivityTypeId(e.target.value)
                                                                    }}
                                                                    required={true}
                                                                >
                                                                    <option value="">Select Activity</option>
                                                                    {activityTypesDetails && activityTypesDetails?.data !== undefined && activityTypesDetails?.data.map((val) => {
                                                                        return (
                                                                            <>
                                                                                {parseInt(accountDetailsByIdData?.data?.stage) === 1 && (parseInt(val?.id) !== 24 && parseInt(val?.id) !== 20 && parseInt(val?.id) !== 23 && parseInt(val?.id) !== 22) &&
                                                                                    <option
                                                                                        value={val?.id}>{val.name}
                                                                                    </option>
                                                                                }
                                                                                {parseInt(accountDetailsByIdData?.data?.stage) !== 1 && (parseInt(val?.id) !== 24 && parseInt(val?.id) !== 20) &&
                                                                                    <option
                                                                                        value={val?.id}>{val.name}
                                                                                    </option>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Schedule Activity
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field">
                                                                <input type="datetime-local"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, e)
                                                                           setCurrentDate(e.target.value)
                                                                       }}
                                                                       my-date-format={"DD/MM/YYYY, HH:mm:ss"}
                                                                       id="validationCustom01"
                                                                       min={new Date().toISOString().split('T')[0] + "T00:00"}
                                                                       value={currentDate}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Activity Date
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field mb-4">
                                                                <DropDownInput
                                                                    data={senior}
                                                                    label={'Tagged Along'}
                                                                    getIdValue={(val) => {
                                                                        setTaggedAlonedReportee(val)
                                                                    }}
                                                                    multipule={true}
                                                                />
                                                            </div>
                                                            {parseInt(activityTypeId) === 27 &&
                                                                reason.map((val, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-sm-6 mt-1 float-field">
                                                                                <select
                                                                                    className="form-control form-control-user"
                                                                                    onChange={(e) => {
                                                                                        handlePitched(e.target.value, i, e)
                                                                                    }}
                                                                                >
                                                                                    <option value="">Select Product
                                                                                        Pitched
                                                                                    </option>
                                                                                    <option
                                                                                        value={"EV"}>EV
                                                                                    </option>
                                                                                    <option
                                                                                        value={"Parking"}>Parking
                                                                                    </option>
                                                                                    <option
                                                                                        value={"Valet"}>Valet
                                                                                    </option>
                                                                                    <option
                                                                                        value={"Corporate"}>Corporate
                                                                                    </option>
                                                                                </select>
                                                                                <label className="large-label float-lb">
                                                                                    Product Pitched
                                                                                </label>
                                                                            </div>

                                                                            <div className="btn-box mb-2">
                                                                                {reason.length !== 1 &&
                                                                                    <>
                                                                                        <button
                                                                                            onClick={(e) => handleRemovePitched(e, i)}
                                                                                            className="btn btn-sm btn-danger ml-3 mb-3 btn-ar">Remove
                                                                                            Product Pitched
                                                                                        </button>
                                                                                    </>
                                                                                }
                                                                                {reason.length - 1 === i &&
                                                                                    <button type="button"
                                                                                            className="btn btn-sm btn-primary ml-3 btn-ar"
                                                                                            onClick={() => handleAddPitched()}>Another
                                                                                        Product Pitched
                                                                                    </button>}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                            <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Description"
                                                                onChange={(e) => {
                                                                    handleInput('description', e.target.value, '', e)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required={true}
                                                            />
                                                                <label className="large-label float-lb">
                                                                    {/*Description*/}
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-12 mtk-1 float-field mb-3 d-mtk-2">
                                                                <FileUpload
                                                                    id={"addAttachment"}
                                                                    accept=".png,.jpg,.jpeg"
                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                    documentUrlData={documentUrlDataPublic}
                                                                    onChange={(e, val) => {
                                                                        handleInput('meta_data', e, 'Document', e)
                                                                    }}
                                                                    prefilledFilename={""}
                                                                    multiple={true}
                                                                >
                                                                    File Attachment
                                                                </FileUpload>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*</div>*/}
                                                <div className="col-md-12 mt-4 d-flex">
                                                    <button className="btn btn-primary btn-user btn-block submit-btn" disabled={disableSubmit}>
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ParkingActivitySave

